import { GetStaticProps } from 'next';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import courseAPI, { COURSE_END_POINT } from 'src/api/course';
import Seo from 'src/components/atoms/seo';
import Section from 'src/components/organisms/section';
import Main from 'src/components/templates/main';
import config from 'src/config';
import { ISection, SectionType } from 'src/interfaces';
import { SWRConfig } from 'swr';

const Sections = ({ fallback }: any) => (
  <SWRConfig value={{ fallback }}>
    <Main coupon scrollToTop>
      <Seo />
      <Section />
    </Main>
  </SWRConfig>
);

type Params = {
  locale: string;
};

export const getStaticPaths = async () => {
  const resSections = await courseAPI.fetchSections();
  const paths = resSections.data
    .filter((sec: ISection) => sec.s_type !== SectionType.Tuxsa && sec.url_name)
    .map((sec: ISection) => ({
      params: { urlName: sec.url_name },
    }));
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context as Params;
  const urlName = context.params?.urlName;
  const path = `${COURSE_END_POINT.COURSES_SECTION}/${urlName}?limit=1&offset=0`;
  const responseCourses = await courseAPI.fetchCoursesBySection(path);
  return {
    props: {
      fallback: {
        [`${COURSE_END_POINT.COURSES_SECTION}/${urlName}`]: responseCourses.data ?? [],
      },
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: config.REVALIDATE_SHORT,
  };
};

export default Sections;
